import styled from "styled-components";
import {StyledButton} from "components/Buttons/DefaultButton/DefaultButton.styles";

export const Page = styled.div`
    height: 100%;
    overflow: auto;
    padding: 0 1rem;
    gap: 1rem;
    display: flex;
    flex-direction: column;
`

export const HeaderDescription = styled.h2`
    color: var(--text-secondary, rgba(0, 0, 0, 0.60));
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;

    font-size: 1.25rem;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 30px */
    letter-spacing: 0.5px;

    @media only screen and (max-width: 600px) {
        font-size: 1rem;
        letter-spacing: 0.15px;
    }
`

export const LocationContainer = styled.div`
    display: flex;
    padding: var(--3, 24px);
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    align-self: stretch;
    font-weight: 600;
    border-radius: var(--3, 24px);
    background: var(--background-success, #F1F7FF);
`

export const ShiftContainer = styled.div`
    display: flex;
    padding: 1rem 1.5rem;

    flex-direction: row;
    justify-content: space-between;
    font-weight: 600;

    border-radius: var(--3, 24px);
    background: #FFF4F4;
    gap: 0.5rem;
    @media only screen and (max-width: 768px) {
        flex-direction: column;
    }
`

export const Title = styled.div`
    color: var(--text-primary, rgba(0, 0, 0, 0.87));
    font-size: var(--typography-h4-size);
    font-style: normal;
    line-height: 123.5%; /* 41.99px */
    letter-spacing: 0.25px;
`

export const Description = styled.div`
    color: var(--text-primary, rgba(0, 0, 0, 0.87));

    font-size: var(--font-size-mid);
    font-style: normal;
    line-height: 150%; /* 24px */
    letter-spacing: 0.15px;
`

export const InfoBox = styled.div`
    color: var(--text-secondary, rgba(0, 0, 0, 0.60));
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 171.429% */
    letter-spacing: 0.17px;
    max-width: 600px;
`

export const ShiftBox = styled.div`
    display: flex;
    flex-direction: column;
    align-self: center;
    gap: .5rem;
`

export const ShiftBoxRate = styled.div`
    display: flex;
    flex-direction: column;
    align-self: center;

    @media only screen and (max-width: 768px) {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }
`

export const ShiftBoxRateTitle = styled.div`
    font-size: var(--font-size-mid);
    line-height: 1.3;
    color: #000;
    font-weight: 600;

    @media only screen and (min-width: 768px) {
        font-size: var(--typography-h5-size);
    }
`
export const ShiftBoxRateValue = styled.div`
    font-size: var(--typography-h4-size);
    line-height: 1.3;
    color: #000;
    font-weight: 600;
    vertical-align: center;
    @media only screen and (min-width: 768px) {
        font-size: var(--typography-h1-size);
    }
`

export const Info = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    margin: 0.5rem;
    
    @media only screen and (max-width: 768px) {
        gap: 0.5rem;
    }
`

export const ButtonBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

export const ShiftButton = styled(StyledButton)`
    max-width: 24rem;
`

export const ShiftIsReadyCancelPolicy = styled.div`
    font-size: 0.7rem;
    text-align: center;
    line-height: 1.5;
    color: #000;
    margin-bottom: 7rem;

    a {
        color: var(--info-main, #0288D1);
        text-decoration: underline;
        font-weight: 300;
        font-size: 0.7rem;
    }
`

export const Link = styled.a`
    color: var(--info-main, #0288D1);
`